import { PlansService } from "@/clients/services/PlansService";
import { QueryKeys } from "@/constants/query-keys";
import { QueryStaleTime } from "@/constants/query-stale-time";
import { useQuery } from "@tanstack/react-query";

export const useGetSearchTags = (mealTime: string) => {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: [QueryKeys.PLAN_ALTERNATIVE_SEARCH_TAGS, mealTime],
    staleTime: QueryStaleTime.LONG,
    enabled: !!mealTime,
    queryFn: async () => {
      const { data } =
        await PlansService.getSearchTagsApiV1PlansAlternativesSearchTagsGet(mealTime);
      return data;
    },
  });

  return { searchTags: data, isLoading, isError, error, refetch };
};
